import { useEffect } from 'react'

export function useGardenUpdates(
  checkWaterRefill,
  updateAllPlantsSeedProgress,
  runAutoGardenerTick
) {
  useEffect(() => {
    const interval = setInterval(() => {
      checkWaterRefill()
      updateAllPlantsSeedProgress()
      if (runAutoGardenerTick) {
        runAutoGardenerTick()
      }
    }, 1000)
    
    return () => clearInterval(interval)
  }, [checkWaterRefill, updateAllPlantsSeedProgress, runAutoGardenerTick])
}
